import filter from "lodash/fp/filter";
import find from "lodash/fp/find";
import flow from "lodash/fp/flow";
import getOr from "lodash/fp/getOr";

import selectUserChoices from "./selectUserChoices";

export default function selectCustomisationNotifications(state) {
  const {
    selectedProductId,
    selectedCustomisationId,
    formData,
    dismissedNotificationIds,
    // isAddingProductToOrder,
  } = state.app;

  const userChoices = selectUserChoices(state);

  // Helper function to find notifications from either customisation or product
  const findNotifications = (productOrCustomisation) =>
    flow(
      getOr([], "notifications"),
      filter(({ id }) => !dismissedNotificationIds.includes(id)),
      filter((notification) => {
        if (!notification.displayIf) {
          return true;
        }

        return Object.keys(notification.displayIf).some((fieldName) => {
          const { greaterThanOrEqual } = notification.displayIf[fieldName];

          if (!userChoices[fieldName]) {
            return true;
          }

          if (greaterThanOrEqual) {
            return (
              parseFloat(userChoices[fieldName].value) >= greaterThanOrEqual
            );
          }

          return true;
        });
      })
    )(productOrCustomisation);

  // Find notifications based on selectedProductId
  if (selectedProductId) {
    const productNotifications = flow(
      getOr([], ["products"]),
      find(({ id }) => id === selectedProductId),
      (product) => {
        if (
          product &&
          product.notifications &&
          product.notifications.length > 0
        ) {
          console.log(
            `Product with ID ${selectedProductId} has notifications.`
          );
        }
        return findNotifications(product);
      }
    )(formData);

    // If there are notifications for the selected product, return them.
    if (productNotifications.length > 0) {
      return productNotifications;
    }
  }

  // Find notifications based on selectedCustomisationId
  if (selectedCustomisationId) {
    const customisationNotifications = flow(
      getOr([], ["products"]),
      find(({ id }) => id === selectedProductId),
      getOr([], "customisations"),
      find(({ id }) => id === selectedCustomisationId),
      findNotifications
    )(formData);

    return customisationNotifications;
  }

  return [];
}
